import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobFileDownloadRequestModel } from '../../models/blob-file-sas-url.model';
import {
  DownloadCSV,
  AllEventMilestone2Data,
  ProgramPaymentFeed
} from '../../models/download-csv.model';
import { EventsReadyforPayment } from '../../models/events-ready-for-payment-report.model';
import { EventsApiBase } from '../mcap-events/api-base';

@Injectable({
  providedIn: 'root'
})
export class EventDownloadCSVService extends EventsApiBase {
  getDownloadCSVFilesList(programtypeGuid: string): Observable<DownloadCSV[]> {
    return this.get<DownloadCSV[]>(
      'api/EventDetails/GetDownloadCSVList/' + programtypeGuid,
      {}
    ) as Observable<DownloadCSV[]>;
  }

  downloadCSVFile(
    downloadModal: BlobFileDownloadRequestModel
  ): Observable<string> {
    return this.post<BlobFileDownloadRequestModel, string>(
      'api/EventDetails/DownloadCSVFile',
      downloadModal,
      { responseType: 'text' }
    ) as Observable<string>;
  }
  exportPayeePaymentReport(
    hasPayeeId: boolean
  ): Observable<EventsReadyforPayment[]> {
    return this.get<EventsReadyforPayment[]>(
      'api/EventDetails/ExportToExcelReadyForPaymentReport?hasPayeeId=' +
        hasPayeeId,
      { responseType: 'json' }
    ) as Observable<EventsReadyforPayment[]>;
  }

  exportMRPPPayeePaymentReport(
    hasPayeeId: boolean
  ): Observable<EventsReadyforPayment[]> {
    return this.get<EventsReadyforPayment[]>(
      'api/EventDetails/ExportToExcelMRPPReadyForPaymentReport?hasPayeeId=' +
        hasPayeeId,
      { responseType: 'json' }
    ) as Observable<EventsReadyforPayment[]>;
  }

  getAllEventsMilestone2Data(): Observable<AllEventMilestone2Data[]> {
    return this.get<AllEventMilestone2Data[]>(
      'api/EventDetails/GetAllEventsMilestone2ExportData',
      {}
    ) as Observable<AllEventMilestone2Data[]>;
  }

  getAllEngagementsMilestone2Data(): Observable<ProgramPaymentFeed[]> {
    return this.get<ProgramPaymentFeed[]>(
      'api/EventDetails/GetProgramPaymentFeedExportData',
      {}
    ) as Observable<ProgramPaymentFeed[]>;
  }
}
